import { UniversalVehicle } from 'models/universalData'
import React from 'react'
import { defaultUniversalVehicle } from 'utils/helpers/extractViewModels'

const VehicleContext = React.createContext<UniversalVehicle>(defaultUniversalVehicle)

const useVehicle = () => {
  const vehicleContext = React.useContext(VehicleContext)
  return vehicleContext
}
export { VehicleContext, useVehicle }
